(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kids"] && !Shopify.designMode) return;
  try {
    
// No JavaScript needed for basic functionality

  } catch(e) { console.error(e); }
})();
})();
